import { Link } from '@change/ds-core-ui';

import type { FieldType, LinkQuestion } from '../../../../../../shared/types';

import { useLinkQuestionField } from './hooks/useLinkQuestionField';

type Props = {
	parent: FieldType;
	question: LinkQuestion;
};

export const LinkQuestionField: React.FC<Props> = ({ parent, question }) => {
	const {
		data: { questionLabel, urlWithParams },
	} = useLinkQuestionField({ parent, question });

	return (
		<div>
			<Link href={urlWithParams} data-testid="reportAbuse-link" data-qa="reportAbuse-link">
				{questionLabel}
			</Link>
		</div>
	);
};
